<div class="survey-container" *ngIf="surveyDetail">

  <!-- Survey Header -->
  <div class="survey-header-card">
    <h2>{{ surveyDetail.survey_title }}</h2>
    <div class="meta">
      <span class="code">{{ surveyDetail.survey_number }}</span>
    </div>
  </div>

  <!-- Sections -->
  <div *ngFor="let section of surveyDetail.questionnaire_sets" 
       class="section-card">

    <div class="section-title">
      {{ section.set_name }}
      <span class="count">
        {{ section.questions.length }} Questions
      </span>
    </div>

    <div *ngFor="let question of section.questions; let i = index"
         class="question-card">
      <div class="q-number">
        Q{{ i + 1 }}
      </div>

      <div class="q-text">
        {{ question.question_text }}
      </div>
    </div>

  </div>

</div>
